import { useEffect } from "react";

/**
 * Lightweight SEO hook — sets document title, description, canonical, and OG tags.
 * Also injects/updates a JSON-LD schema block by id if provided.
 */
export function useSEO({
  title,
  description,
  canonical,
  ogImage,
  jsonLd,
  jsonLdId = "seo-jsonld",
}) {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (attr, key, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    if (ogImage) setMeta("property", "og:image", ogImage);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);

    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.rel = "canonical";
        document.head.appendChild(link);
      }
      link.href = canonical;
    }

    if (jsonLd) {
      let s = document.getElementById(jsonLdId);
      if (!s) {
        s = document.createElement("script");
        s.type = "application/ld+json";
        s.id = jsonLdId;
        document.head.appendChild(s);
      }
      s.textContent = JSON.stringify(jsonLd);
    }
  }, [title, description, canonical, ogImage, jsonLd, jsonLdId]);
}
